import React, { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import { toast } from 'react-toastify';
import axiosInstance from '../../api/axios';import {
    Button,
    Col,
    Form,
    Row,
    Spinner,
} from 'react-bootstrap';
import { ArrowLeft } from 'react-bootstrap-icons';
import Header from '../../layouts/Header';
import { useNavigate } from 'react-router-dom';
import OutletSelect from '../../components/OutletSelect';
import { he } from 'date-fns/locale';

/* ─── inline styles ─────────────────────────────────────────────── */
const S = {
    page: {
        background: '#f3f6f8',
        minHeight: '100vh',
        padding: '24px',
        // fontFamily: 'Arial, Helvetica, sans-serif',
    },
    /* top filter card */
    filterCard: {
        background: '#ffffff',
        borderRadius: 16,
        padding: '24px 28px',
        marginBottom: 24,
        boxShadow: '0 1px 4px rgba(0,0,0,.06)',
    },
    filterHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20,
    },
    filterTitle: {
        margin: 0,
        fontSize: 20,
        fontWeight: 700,
        color: '#202124',
    },
    /* hero / brand bar */
    heroBand: {
        background: '#09A5F7',
        borderRadius: '20px 20px 0 0',
        padding: '0',
        overflow: 'hidden',
    },
    heroBandImg: {
        width: '100%',
        display: 'block',
        maxHeight: 130,
        // height: '100%',
        objectFit: 'cover',
    },
    /* main content card */
    mainCard: {
        background: '#f7f7f8',
        // borderRadius: '0 0 20px 20px',
        padding: '32px 32px',
        boxShadow: '0 4px 24px rgba(0,0,0,.08)',
    },
    /* report header inside card */
    reportHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        marginBottom: 24,
    },
    reportIcon: {
        width: 56,
        height: 56,
        lineHeight: '56px',
        textAlign: 'center',
        background: '#09A5F7',
        borderRadius: '50%',
        fontSize: 28,
        color: '#fff',
        flexShrink: 0,
    },
    reportTitle: {
        margin: 0,
        fontSize: 26,
        fontWeight: 700,
        color: '#202124',
    },
    reportSubtitle: {
        margin: '6px 0 0',
        fontSize: 14,
        color: '#5f6368',
    },
    /* meta row */
    metaBox: {
        background: '#eaf1f7',
        borderRadius: 14,
        display: 'flex',
        marginBottom: 24,
        overflow: 'hidden',
    },
    metaCell: {
        flex: 1,
        padding: '22px 26px',
        borderRight: '1px solid #c7d7e6',
    },
    metaCellLast: {
        flex: 1,
        padding: '22px 26px',
    },
    metaLabel: { fontSize: 13, color: '#6b7280', marginBottom: 6 },
    metaValue: { fontSize: 18, fontWeight: 700, color: '#111827' },
    /* KPI cards */
    kpiGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 12,
        marginBottom: 24,
    },
    kpiCard: (border) => ({
        background: '#fff',
        border: `1px solid ${border}`,
        borderRadius: 16,
        padding: 18,
    }),
    kpiCardTop: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
    },
    kpiEmoji: { fontSize: 24 },
    kpiBadge: (bg, color) => ({
        background: bg,
        color,
        fontSize: 11,
        fontWeight: 700,
        padding: '5px 8px',
        borderRadius: 20,
    }),
    kpiLabel: { fontSize: 13, color: '#5f6368', marginTop: 14 },
    kpiValue: { fontSize: 26, fontWeight: 800, color: '#111827', marginTop: 4, lineHeight: 1.2 },
    kpiSub: { fontSize: 12, color: '#6b7280', marginTop: 5 },
    kpiDivider: { height: 1, background: '#edf2f7', margin: '14px 0 10px' },
    kpiDetailRow: {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: 12,
        color: '#6b7280',
        marginTop: 6,
    },
    /* two-col panels */
    twoCol: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 24 },
    panel: {
        background: '#fff',
        border: '1px solid #d9dee5',
        borderRadius: 14,
        padding: 18,
    },
    panelTitle: { fontSize: 15, fontWeight: 800, color: '#111827', marginBottom: 14 },
    panelRow: {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: 14,
        color: '#374151',
        padding: '8px 0',
        borderTop: '1px solid #eef2f7',
    },
    panelRowFirst: {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: 14,
        color: '#374151',
        padding: '8px 0',
    },
    /* metrics table */
    tableWrap: {
        borderRadius: 14,
        overflow: 'hidden',
        border: '1px solid #d9dee5',
        marginBottom: 24,
    },
    tableHead: {
        display: 'grid',
        gridTemplateColumns: '60px 1fr 200px',
        background: '#09A5F7',
        padding: '13px 0',
    },
    thCell: (align) => ({
        fontSize: 14,
        color: '#fff',
        fontWeight: 700,
        padding: '0 16px',
        textAlign: align || 'left',
    }),
    tableRow: (bg) => ({
        display: 'grid',
        gridTemplateColumns: '60px 1fr 200px',
        borderTop: '1px solid #e5e7eb',
        background: bg || '#fff',
    }),
    tdNum: {
        fontSize: 14,
        color: '#6b7280',
        padding: '14px 12px',
        textAlign: 'center',
    },
    tdLabel: (bold) => ({
        fontSize: 14,
        color: '#202124',
        padding: '14px 16px',
        fontWeight: bold ? 700 : 400,
    }),
    tdVal: (color, bold, size) => ({
        fontSize: size || 14,
        color: color || '#202124',
        padding: '14px 16px',
        textAlign: 'right',
        fontWeight: bold ? 700 : 400,
    }),
    /* revenue flow note */
    noteBox: {
        background: '#eef6ff',
        border: '1px solid #d6e8ff',
        borderRadius: 14,
        padding: '14px 18px',
        fontSize: 13,
        lineHeight: '22px',
        color: '#475467',
        marginBottom: 32,
    },
    /* footer */
    footer: {
        background: '#09A5F7',
        borderRadius: '0 0 20px 20px',
        padding: '22px 20px 26px',
        textAlign: 'center',
        color: '#fff',
        fontSize: 13,
        lineHeight: '22px',
    },
    /* section heading */
    sectionHeading: {
        fontSize: 15,
        fontWeight: 800,
        color: '#111827',
        marginBottom: 14,
    },
    /* time distribution bar */
    timeBarWrap: { background: '#e5e7eb', borderRadius: 6, height: 8, flex: 1, margin: '0 12px' },
    timeBarFill: (pct, color) => ({
        width: `${pct}%`,
        background: color || '#09A5F7',
        height: '100%',
        borderRadius: 6,
    }),
    /* product rank badge */
    rankBadge: (bg) => ({
        width: 26, height: 26, borderRadius: '50%',
        background: bg, color: '#fff',
        fontSize: 12, fontWeight: 800,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
    }),
    /* empty / loading states */
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 0',
        color: '#9ca3af',
    },
};

/* ─── helpers ───────────────────────────────────────────────────── */
const fmt = (n, fallback = '0.00') =>
    n != null && !isNaN(n) ? Number(n).toFixed(2) : fallback;

const fmtINR = (n) => `₹ ${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

/* ─── sub-components ─────────────────────────────────────────────── */
const KpiCard = ({ emoji, badge, badgeBg, badgeColor, borderColor, label, value, sub, detail1L, detail1V, detail1Color, detail2L, detail2V, detail2Color }) => (
    <div style={S.kpiCard(borderColor)}>
        <div style={S.kpiCardTop}>
            <span style={S.kpiEmoji}>{emoji}</span>
            <span style={S.kpiBadge(badgeBg, badgeColor)}>{badge}</span>
        </div>
        <div style={S.kpiLabel}>{label}</div>
        <div style={S.kpiValue}>{value}</div>
        <div style={S.kpiSub}>{sub}</div>
        <div style={S.kpiDivider} />
        <div style={S.kpiDetailRow}>
            <span>{detail1L}</span>
            <span style={{ fontWeight: 700, color: detail1Color || '#111827' }}>{detail1V}</span>
        </div>
        <div style={S.kpiDetailRow}>
            <span>{detail2L}</span>
            <span style={{ fontWeight: 700, color: detail2Color || '#111827' }}>{detail2V}</span>
        </div>
    </div>
);

const MetricRow = ({ idx, label, value, bg, labelBold, valColor, valBold, valSize, note }) => (
    <div style={S.tableRow(bg)}>
        <div style={S.tdNum}>{idx}</div>
        <div style={S.tdLabel(labelBold)}>
            {label}
            {note && <span style={{ color: '#2563eb', fontWeight: 400, fontSize: 12, marginLeft: 6 }}>{note}</span>}
        </div>
        <div style={S.tdVal(valColor, valBold, valSize)}>{value}</div>
    </div>
);

/* ═══════════════════════════════════════════════════════════════════ */
const DaySummaryReport = () => {
    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const navigate = useNavigate();

    const accessToken = localStorage.getItem('authToken');
    const [subBtnLoading, setSubBtnLoading] = useState(false);
    const [selectedOutlet, setSelectedOutlet] = useState(null);
    const [selectedOutletName, setSelectedOutletName] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [CouponCodeOrders, setCouponCodeOrders] = useState([]);
    const [totalOrdersSummary, setTotalOrdersSummary] = useState({});
    const [dayOrderSummaryData, setDayOrderSummaryData] = useState({});  // ← NEW
    const [userInfo, setuserInfo] = useState({});
    const [clicked, setClicked] = useState(false);

    useEffect(() => {
        const now = new Date();
        const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
        yesterday.setHours(23, 59, 59, 999);
        setStartDate(yesterday);
    }, []);

    useEffect(() => {
        if (selectedOutlet?.label) setSelectedOutletName(selectedOutlet.label);
    }, [selectedOutlet]);

    const getSummary = async (date, outlet) => {
        setLoading(true);
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const updatedStartDate = date ? date.toISOString().split('T')[0] : null;
            const response = await axiosInstance.post('order/summary', { date: updatedStartDate, outlet }, { headers });

            setTotalOrdersSummary(response?.data?.data?.totalOrdersSummary || {});
            setDayOrderSummaryData(response?.data?.data?.dayOrderSummaryData || {});  // ← NEW
            setCouponCodeOrders(response?.data?.data?.couponCodeOrders || []);
            setuserInfo(response?.data?.data?.userInfo || {});

            if (response?.data?.status === true) {
                toast.success('Data Fetched Successfully', { position: 'top-right', autoClose: 3000, theme: 'light' });
            } else {
                toast.info('No records available. Please try again later.', { position: 'top-right', autoClose: 3000, theme: 'light' });
            }
        } catch (error) {
            const status = error?.response?.status;
            const msg =
                status === 406 ? error.response?.data?.error?.message || error.response?.data?.error
                    : status === 412 ? error.response?.data?.data?.message
                        : status === 500 ? error.response?.data?.error
                            : 'Something went wrong';
            toast.error(msg, { position: 'top-right', autoClose: 3000, theme: 'light' });
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async () => {
        if (!selectedOutlet) return;
        setSubBtnLoading(true);
        setClicked(true);
        const adj = new Date(startDate.setHours(23, 59, 59, 999));
        await getSummary(adj, selectedOutlet.value);
        setSubBtnLoading(false);
    };

    /* ── derived values ── */
    const tos = totalOrdersSummary;
    const dos = dayOrderSummaryData;

    // Helper to safely parse $numberDecimal fields from dayOrderSummaryData
    const val = (field) => parseFloat(dos[field]?.$numberDecimal ?? 0);

    const netRevenue          = val('totalTaxableAmount');          // taxable amount before tax
    const grandTotal          = val('grandTotalAmount');            // final amount including tax
    const taxCollected        = val('totalTaxAmount');              // total tax collected
    const discount            = val('totalDiscountAmount');         // total discount given
    const cancelledVal        = val('cancelledOrderAmount');        // cancelled orders value
    const kioskRevenue        = val('kioskGrandTotalAmount');       // kiosk grand total (incl. tax)
    const foodAmount          = val('totalFoodAmount');             // food revenue
    const beverageAmount      = val('totalBeverageAmount');         // beverage revenue
    const complimentaryAmount = val('complimentaryTaxableAmount');  // complimentary taxable amount
    const complimentaryCount  = parseFloat(dos['totalComplimentaryOrderCount']?.$numberDecimal ?? 0);
    const onlineRevenue       = dos.totalOnlineRevenue || 0;        // online sales revenue (plain number)
    const exhaustedCount      = dos.totalExhaustedCount || 0;       // product exhausted count
    const topProducts         = dos.topSellingProducts || [];
    const timeSlots           = dos.timeDistribution || [];

    const avgOrderValue = dos?.averageOrderValue || 0;
    const appOrders = dos?.appKioskInfo?.appOrders || 0;
    const appPct = dos?.appKioskInfo?.appOrderPercent || 0;
    const kioskPct = dos?.appKioskInfo?.kioskOrderPercent || 0;

    // For time distribution bar chart — find max sales to normalise bars
    const maxSlotSales = timeSlots.length ? Math.max(...timeSlots.map(s => s.netSales || 0)) : 1;

    const formattedDate = startDate?.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`} style={{ ...S.page, background: skin === 'dark' ? '#1a1a2e' : '#f3f6f8' }}>

                {/* ── Filter Bar ── */}
                <div style={S.filterCard}>
                    <div style={S.filterHeader}>
                        <h4 style={S.filterTitle}>
                            <i className="bi bi-calendar-day me-2" />
                            DAY SUMMARY REPORT — {formattedDate}
                        </h4>
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => navigate('/reports/all-reports')}
                            className="d-flex align-items-center fw-semibold"
                            style={{ height: 38 }}
                        >
                            <ArrowLeft className="me-1" /> Back to Reports
                        </Button>
                    </div>

                    <div style={{ background: '#f8fafc', borderRadius: 12, padding: '16px 20px' }}>
                        <Row className="g-3 align-items-end">
                            <Col md={4}>
                                <Form.Group>
                                    <OutletSelect
                                        value={selectedOutlet}
                                        onChange={(opt) => setSelectedOutlet(opt)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group>
                                    <Form.Label className="fw-semibold" style={{ fontSize: 13 }}>
                                        <i className="bi bi-calendar me-1" />Date
                                    </Form.Label>
                                    <DatePicker
                                        selected={startDate}
                                        onChange={(d) => setStartDate(d)}
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="Select Date"
                                        className="form-control border-secondary"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Button
                                    variant="primary"
                                    onClick={handleSubmit}
                                    className="w-100"
                                    disabled={!selectedOutlet || subBtnLoading}
                                >
                                    {subBtnLoading ? <Spinner size="sm" animation="border" /> : 'Generate Report'}
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </div>

                {/* ── Report Body ── */}
                {loading ? (
                    <div style={S.emptyState}>
                        <Spinner animation="border" variant="primary" />
                        <span style={{ marginTop: 12 }}>Loading report data…</span>
                    </div>
                ) : !clicked ? (
                    <div style={S.emptyState}>
                        <i className="bi bi-clipboard-data" style={{ fontSize: 48 }} />
                        <h5 style={{ marginTop: 16, color: '#6b7280' }}>
                            Please select an outlet and date to view day summary
                        </h5>
                    </div>
                ) : (
                    <div>
                        {/* ── Hero band ── */}
                        <div style={S.heroBand}>
                            <img
                                src="https://i.postimg.cc/8z8cvk19/Frame-37242.png"
                                alt="Xpanse"
                                style={S.heroBandImg}
                            />
                        </div>

                        <div style={S.mainCard}>

                            {/* Report header */}
                            <div style={S.reportHeader}>
                                <div style={S.reportIcon}>📊</div>
                                <div>
                                    <h2 style={S.reportTitle}>Daily Summary Report</h2>
                                    <p style={S.reportSubtitle}>Outlet performance dashboard for the selected date</p>
                                </div>
                            </div>

                            {/* Meta: outlet + date */}
                            <div style={S.metaBox}>
                                <div style={S.metaCell}>
                                    <div style={S.metaLabel}>Outlet</div>
                                    <div style={S.metaValue}>{selectedOutletName || '—'}</div>
                                </div>
                                <div style={S.metaCellLast}>
                                    <div style={S.metaLabel}>Date</div>
                                    <div style={S.metaValue}>{formattedDate}</div>
                                </div>
                            </div>

                            {/* KPI Cards */}
                            <div style={S.kpiGrid}>
                                <KpiCard
                                    emoji="🧾" badge="ORDERS" badgeBg="#eaf8ef" badgeColor="#159947" borderColor="#d7efdf"
                                    label="Total Orders" value={tos.totalOrdersCount || 0} sub="Completed order volume"
                                    detail1L="With Coupons" detail1V={tos.totalCouponOrdersCount || 0} detail1Color="#dc2626"
                                    detail2L="Without Coupons" detail2V={tos.totalNonCouponOrdersCount || 0} detail2Color="#15803d"
                                />
                                <KpiCard
                                    emoji="💰" badge="NET" badgeBg="#eef4ff" badgeColor="#2563eb" borderColor="#d8e4ff"
                                    label="Revenue Before Tax" value={fmtINR(netRevenue)} sub="Net sales excluding tax"
                                    detail1L="Kiosk Revenue" detail1V={fmtINR(kioskRevenue)} detail1Color="#2563eb"
                                    detail2L="Discount" detail2V={fmtINR(discount)} detail2Color="#ea580c"
                                />
                                <KpiCard
                                    emoji="📈" badge="FINAL" badgeBg="#ecfdf3" badgeColor="#15803d" borderColor="#d5f5e2"
                                    label="Final Revenue" value={fmtINR(grandTotal)} sub="Including tax"
                                    detail1L="Tax Collected" detail1V={fmtINR(taxCollected)} detail1Color="#15803d"
                                    detail2L="Cancelled Value" detail2V={fmtINR(cancelledVal)} detail2Color="#dc2626"
                                />
                                <KpiCard
                                    emoji="🛒" badge="AVG" badgeBg="#fff7ed" badgeColor="#ea580c" borderColor="#ffedd5"
                                    label="Avg Order Value" value={fmtINR(avgOrderValue)} sub="Revenue / orders"
                                    detail1L="App Orders" detail1V={appOrders} detail1Color="#2563eb"
                                    detail2L="Kiosk Orders" detail2V={dos.totalKioskOrdersCount || 0} detail2Color="#159947"
                                />
                            </div>

                            {/* Two-col panels */}
                            <div style={S.twoCol}>
                                <div style={S.panel}>
                                    <div style={S.panelTitle}>📱 Order Source Split</div>
                                    <div style={S.panelRowFirst}>
                                        <span>App Orders</span>
                                        <span>
                                            <strong style={{ marginRight: 12 }}>{appOrders}</strong>
                                            <strong style={{ color: '#2563eb' }}>{appPct}%</strong>
                                        </span>
                                    </div>
                                    <div style={S.panelRow}>
                                        <span>Kiosk Orders</span>
                                        <span>
                                            <strong style={{ marginRight: 12 }}>{tos.totalKioskOrdersCount || 0}</strong>
                                            <strong style={{ color: '#159947' }}>{kioskPct}%</strong>
                                        </span>
                                    </div>
                                </div>

                                <div style={S.panel}>
                                    <div style={S.panelTitle}>📦 Order Status Funnel</div>
                                    <div style={S.panelRowFirst}>
                                        <span>Total Orders</span>
                                        <strong>{tos.totalOrdersCount || 0}</strong>
                                    </div>
                                    <div style={S.panelRow}>
                                        <span>Completed Orders</span>
                                        <strong style={{ color: '#159947' }}>
                                            {(tos.totalOrdersCount || 0) - (tos.totalCancelledOrdersCount || 0)}
                                        </strong>
                                    </div>
                                    <div style={S.panelRow}>
                                        <span>Cancelled Orders</span>
                                        <strong style={{ color: '#dc2626' }}>{tos.totalCancelledOrdersCount || 0}</strong>
                                    </div>
                                </div>
                            </div>

                            {/* Metrics table */}
                            <div style={S.tableWrap}>
                                <div style={S.tableHead}>
                                    <div style={S.thCell('center')}>#</div>
                                    <div style={S.thCell('left')}>Metric</div>
                                    <div style={S.thCell('right')}>Value</div>
                                </div>

                                <MetricRow idx={1} label="Orders Using Coupons" value={tos.totalCouponOrdersCount || 0} />
                                <MetricRow idx={2} label="Orders Without Coupons" value={tos.totalNonCouponOrdersCount || 0} bg="#fbfbfc" />
                                <MetricRow idx={3} label="App Orders" value={appOrders} valColor="#2563eb" />
                                <MetricRow idx={4} label="Kiosk Orders" value={tos.totalKioskOrdersCount || 0} bg="#fbfbfc" valColor="#159947" />
                                <MetricRow idx={5} label="Cancelled Orders" value={tos.totalCancelledOrdersCount || 0} valColor="#ff3b30" />
                                <MetricRow idx={6} label="Total Orders" value={tos.totalOrdersCount || 0} bg="#eefbf3" labelBold valColor="#159947" valBold />
                                <MetricRow idx={7} label="Average Order Value" value={fmtINR(avgOrderValue)} bg="#fff7ed" valColor="#ea580c" />
                                <MetricRow idx={8} label="Coupon Discount Given" value={fmtINR(discount)} valColor="#ea580c" />
                                <MetricRow idx={9} label="Kiosk Revenue" value={fmtINR(kioskRevenue)} bg="#fbfbfc" />
                                <MetricRow idx={10} label="Revenue Before Tax" value={fmtINR(netRevenue)} bg="#eef4ff" labelBold valColor="#2563eb" valBold />
                                <MetricRow idx={11} label="Cancelled Orders Value" value={`- ${fmtINR(cancelledVal)}`} valColor="#ff3b30" />
                                <MetricRow idx={12} label="Net Revenue (Excl. Tax)" value={fmtINR(netRevenue)} bg="#f0fdf4" labelBold valBold />
                                <MetricRow idx={13} label="Tax Collected" value={`+ ${fmtINR(taxCollected)}`} bg="#fff1f2" valColor="#dc2626" />

                                {/* Grand Total */}
                                <div style={{ ...S.tableRow('#dcfce7'), borderTop: '1px solid #dbe9de' }}>
                                    <div style={{ ...S.tdNum, fontWeight: 800, fontSize: 16 }}>14</div>
                                    <div style={{ ...S.tdLabel(true), fontSize: 16, color: '#14532d' }}>Final Revenue (Including Tax)</div>
                                    <div style={{ ...S.tdVal('#15803d', true, 18) }}>{fmtINR(grandTotal)}</div>
                                </div>

                                {/* User info rows */}
                                <MetricRow idx={15} label="Users With Orders" value={`${userInfo?.totalUsersWithOrders || 0} nos`} />
                                <MetricRow idx={16} label="Referred Users With Orders" value={`${userInfo?.totalReferredUsersWithOrders || 0} nos`} bg="#fbfbfc" />
                                <MetricRow idx={17} label="Deleted Users With Orders" value={`${userInfo?.totalDeletedUsersWithOrders || 0} nos`} />
                                <MetricRow
                                    idx={18}
                                    label="Total Users Joined Today"
                                    note="(Count from all outlets)"
                                    value={`${userInfo?.totalUsersJoinedOnGivenDate || 0} nos`}
                                    bg="#eef4ff"
                                    labelBold
                                    valColor="#2563eb"
                                    valBold
                                />

                                {/* Coupon rows */}
                                {CouponCodeOrders?.map((coupon, i) => (
                                    <MetricRow
                                        key={i}
                                        idx={19 + i}
                                        label={<>COUPON — <span style={{ color: '#2563eb', fontWeight: 700 }}>{coupon?.coupon?.couponCode}</span></>}
                                        value={`${coupon?.count || 0} nos | ${fmtINR(coupon?.totalCouponDiscount)}`}
                                        bg={i % 2 === 0 ? '#fbfbfc' : '#fff'}
                                    />
                                ))}
                            </div>

                            {/* Revenue flow note */}
                            <div className='mb-4' style={S.noteBox}>
                                <strong style={{ color: '#1d4ed8' }}>Revenue Flow: </strong>
                                Revenue Before Tax → Net Revenue (Excl. Tax) → Tax Collected →{' '}
                                <strong style={{ color: '#15803d' }}>Final Revenue (Including Tax)</strong>
                            </div>

                            {/* ── Sales Breakdown ── */}
                            <div style={{ ...S.twoCol, gridTemplateColumns: '1fr 1fr', marginBottom: 24 }}>
                                {/* Food & Beverage */}
                                <div style={S.panel}>
                                    <div style={S.panelTitle}>🍽️ Food & Beverage Breakdown</div>
                                    <div style={S.panelRowFirst}>
                                        <span>Food Amount</span>
                                        <strong style={{ color: '#ea580c' }}>{fmtINR(foodAmount)}</strong>
                                    </div>
                                    <div style={S.panelRow}>
                                        <span>Beverage Amount</span>
                                        <strong style={{ color: '#2563eb' }}>{fmtINR(beverageAmount)}</strong>
                                    </div>
                                    <div style={S.panelRow}>
                                        <span>Complimentary Amount</span>
                                        <strong style={{ color: '#7c3aed' }}>{fmtINR(complimentaryAmount)}</strong>
                                    </div>
                                    <div style={S.panelRow}>
                                        <span>Complimentary Order Count</span>
                                        <strong style={{ color: '#7c3aed' }}>{complimentaryCount}</strong>
                                    </div>
                                </div>

                                {/* Online & Inventory */}
                                <div style={S.panel}>
                                    <div style={S.panelTitle}>🌐 Online & Inventory</div>
                                    <div style={S.panelRowFirst}>
                                        <span>Online Revenue</span>
                                        <strong style={{ color: '#0891b2' }}>{fmtINR(onlineRevenue)}</strong>
                                    </div>
                                    <div style={S.panelRow}>
                                        <span>Online Order Count</span>
                                        <strong style={{ color: '#0891b2' }}>{dos.onlineSalesCount || 0}</strong>
                                    </div>
                                    <div style={S.panelRow}>
                                        <span>Total Exhausted Items</span>
                                        <strong style={{ color: '#dc2626' }}>{exhaustedCount}</strong>
                                    </div>
                                </div>
                            </div>

                            {/* ── Top Selling Products ── */}
                            {topProducts.length > 0 && (
                                <div style={{ ...S.panel, marginBottom: 24 }}>
                                    <div style={S.panelTitle}>🏆 Top Selling Products</div>
                                    {topProducts.map((p, i) => {
                                        const rankColors = ['#f59e0b', '#9ca3af', '#b45309'];
                                        const rankColor = rankColors[i] || '#09A5F7';
                                        const productTotal = parseFloat(p.totalAmount?.$numberDecimal ?? 0);
                                        return (
                                            <div
                                                key={p._id || i}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 14,
                                                    padding: '10px 0',
                                                    borderTop: i === 0 ? 'none' : '1px solid #eef2f7',
                                                }}
                                            >
                                                <div style={S.rankBadge(rankColor)}>#{i + 1}</div>
                                                <div style={{ flex: 1 }}>
                                                    <div style={{ fontSize: 14, fontWeight: 600, color: '#111827', textTransform: 'capitalize' }}>
                                                        {p.productName}
                                                    </div>
                                                    <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>
                                                        Qty sold: <strong>{p.totalQuantitySold}</strong>
                                                    </div>
                                                </div>
                                                <div style={{ textAlign: 'right' }}>
                                                    <div style={{ fontSize: 15, fontWeight: 700, color: '#15803d' }}>{fmtINR(productTotal)}</div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {/* ── Time Distribution ── */}
                            {timeSlots.length > 0 && (
                                <div style={{ ...S.panel, marginBottom: 24 }}>
                                    <div style={S.panelTitle}>⏱️ Hourly Order Distribution</div>
                                    {timeSlots.map((slot, i) => {
                                        const pct = maxSlotSales > 0 ? Math.round((slot.netSales / maxSlotSales) * 100) : 0;
                                        const barColor = slot.netSales === maxSlotSales ? '#15803d' : '#09A5F7';
                                        return (
                                            <div
                                                key={slot._id || i}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '9px 0',
                                                    borderTop: i === 0 ? 'none' : '1px solid #eef2f7',
                                                    gap: 8,
                                                }}
                                            >
                                                <div style={{ fontSize: 13, color: '#374151', width: 120, flexShrink: 0 }}>
                                                    {slot.slotLabel}
                                                </div>
                                                <div style={S.timeBarWrap}>
                                                    <div style={S.timeBarFill(pct, barColor)} />
                                                </div>
                                                <div style={{ fontSize: 13, fontWeight: 700, color: '#111827', width: 90, textAlign: 'right', flexShrink: 0 }}>
                                                    {fmtINR(slot.netSales)}
                                                </div>
                                                <div style={{ fontSize: 12, color: '#6b7280', width: 70, textAlign: 'right', flexShrink: 0 }}>
                                                    {slot.orderCount} order{slot.orderCount !== 1 ? 's' : ''}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                        </div>{/* /mainCard */}

                        {/* Footer */}
                        <div style={S.footer}>
                            <p style={{ margin: 0 }}>
                                This is an automated daily summary report generated by the Xpanse reporting system.
                            </p>
                        </div>

                    </div>
                )}
            </div>
        </React.Fragment>
    );
};

export default DaySummaryReport;